<template>
  <div class="list-group">
    <template v-for="(permission, index) in permissions" :key="index">
      <a
        :class="{
          'list-group-item': true,
          'list-group-item-action': true,
          active: isChildOpen[index]
        }"
        :style="{ paddingLeft: padding + 'rem' }"
        data-trigger-point="toggle-childs"
        @click="toggleChilds($event, permission, index)"
      >
        <input
          type="checkbox"
          name="permissionCheckbox"
          v-if="
            checkAll === true ||
            (userPermissionList[permission.id] && checkAll !== false)
          "
          class="form-check-input"
          @click="checkBoxClick(index, $event)"
          checked
          :value="permission.id" />
        <input
          type="checkbox"
          name="permissionCheckbox"
          v-else
          class="form-check-input"
          @click="checkBoxClick(index, $event)"
          :value="permission.id" />
        <span
          :class="{ 'backend-text': permission.route_type === 'backend' }"
          data-trigger-point="toggle-childs"
        >
          {{
            permission.display_name
              ? permission.display_name
              : permission.route_name
          }}
        </span>
        <span
          v-if="permission.childs && permission.childs.length > 0"
          data-trigger-point="toggle-childs"
          class="icon"
        >
          <i
            v-if="isChildOpen[index]"
            class="bi bi-chevron-down"
            data-trigger-point="toggle-childs"
          ></i>
          <i
            v-else
            class="bi bi-chevron-right"
            data-trigger-point="toggle-childs"
          ></i> </span
      ></a>

      <!-- Recursively call the same component again if child permissions exist -->
      <permissionList
        v-if="permission.childs && permission.childs.length > 0"
        v-show="isChildOpen[index]"
        :permissions="permission.childs"
        :userPermissionList="userPermissionList"
        :padding="padding + 2"
        :checkAll="isCheckAll[index]"
      ></permissionList>
    </template>
  </div>
</template>

<script>
import permissionList from './permissionList.vue';

export default {
  components: {
    permissionList
  },
  props: ['permissions', 'userPermissionList', 'padding', 'checkAll'],
  data() {
    return {
      isChildOpen: [],
      checkedPermissions: [],
      isCheckAll: []
    };
  },
  mounted() {
    this.mapPermissions();
    this.mapCheckAll();
  },
  watch: {
    checkAll: function () {
      this.mapCheckAll();
    }
  },
  methods: {
    mapPermissions() {
      this.isChildOpen = [];
      this.permissions.forEach(() => {
        this.isChildOpen.push(false);
      });
    },
    mapCheckAll() {
      this.isCheckAll = [];
      this.permissions.forEach(() => {
        this.isCheckAll.push(this.checkAll);
      });
    },
    checkBoxClick(index, event) {
      this.isCheckAll[index] = event.target.checked;
    },
    toggleChilds(e, permission, index) {
      if (
        e.target.dataset.triggerPoint === 'toggle-childs' &&
        permission.childs &&
        permission.childs.length > 0
      ) {
        this.isChildOpen[index] = !this.isChildOpen[index];
      }
    }
  }
};
</script>

<style scoped>
.list-group a .icon {
  float: right;
}
.list-group a input {
  margin-right: 10px;
}
.active {
  background-color: #652f8f;
  border-color: #652f8f;
}
.backend-text {
  color: lightslategray;
}
</style>
